<template>
  <v-card class="card-pad pa-0 pb-2 mt-4">
    <v-dialog v-model="removeParameterModal" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir este parâmetro?') }}
          </div>

          <v-btn
            :disabled="removeParameterLoading"
            class="ma-1"
            color="grey"
            text
            @click="removeParameterModal = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="removeParameterLoading"
            class="ma-1"
            color="error"
            text
            @click="removeParameter"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="manageParameterModal" max-width="600">
      <ManageParameter
        :templateId="templateId"
        :parameterId="parameterId"
        :key="manageParameterModalKey"
        @close="manageParameterModal = false"
        @confirm="reloadAndClose"
      />
    </v-dialog>

    <v-dialog v-model="deleteRangeModal" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir este ponto?') }}
          </div>

          <v-btn
            :disabled="deleteLoading"
            class="ma-1"
            color="grey"
            text
            @click="deleteRangeModal = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="deleteLoading"
            class="ma-1"
            color="error"
            text
            @click="removeMetricRange"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="rangeModal" max-width="300">
      <ManageRange
        :selectedRange="selectedRange"
        :parameterId="parameterId"
        :key="rangeModalKey"
        @close="rangeModal = false"
        @confirm="reloadAndClose"
      />
    </v-dialog>

    <div class="px-4 py-3">
      <v-row class="ma-0" dense justify="end">
        <v-col class="d-flex align-center">
          <strong>Parâmetros Template</strong>
          <v-spacer></v-spacer>
          <v-btn
            class="primary-button mr-0"
            depressed
            @click="openAddParameterModal"
          >
            Novo parâmetro
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-divider />

    <div class="pa-4 text-center">
      <strong v-if="parameters.length == 0">Nenhum parâmetro encontrado</strong>

      <v-simple-table class="main-table" v-else>
        <thead>
          <tr>
            <th class="text-center"></th>
            <th class="text-center">Parâmetro</th>
            <th class="text-center">Métrica</th>
            <th class="text-center">Tolerância</th>
            <th class="text-center">Pontos</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in parameters" :key="item.id">
            <td class="text-center"></td>
            <td class="text-center">
              {{ item.name }}
            </td>
            <td class="text-center">
              {{ item.metric ? item.metric.name : '' }}
            </td>
            <td class="text-center">
              <h3>
                {{ item.tolerance }} {{ item.isAbsoluteValue ? '' : '%' }}
              </h3>
            </td>
            <td class="text-center">
              <v-btn
                class="mr-0 mt-4"
                color="primary"
                depressed
                @click.stop="openAddRange(item.id)"
                block
              >
                <strong> Novo ponto </strong>
                <v-icon class="ml-2 mb-1">mdi-plus</v-icon>
              </v-btn>

              <strong
                class="font-weight-bold"
                v-if="item.ranges && item.ranges.length == 0"
              >
                <div class="my-3">Nenhum ponto encontrada</div>
              </strong>

              <v-simple-table class="main-table" v-else>
                <thead>
                  <tr>
                    <th class="text-center"></th>
                    <th class="text-center">Ponto</th>
                    <th class="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="range in item.ranges" :key="range.id">
                    <td></td>
                    <td>{{ range.range }}</td>
                    <td>
                      <v-btn
                        fab
                        tile
                        style="border-radius: 9px"
                        depressed
                        class="ma-1 mb-2"
                        x-small
                        color="primary"
                        @click.stop="openEditRange(range)"
                      >
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>

                      <v-btn
                        fab
                        tile
                        style="border-radius: 9px"
                        depressed
                        class="ma-1 mb-2"
                        x-small
                        color="error"
                        @click.stop="openRemoveModal(range.id)"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </td>
            <td>
              <v-btn
                color="primary"
                depressed
                small
                @click.stop="openEditParameter(item)"
              >
                editar
              </v-btn>
              <br />
              <v-btn
                @click="openRemoveParameterModal(item)"
                color="error"
                depressed
                small
              >
                Remover
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import ManageParameter from './manageParameter.vue'
import ManageRange from './manageRange.vue'

export default {
  name: 'Parameters',

  components: {
    ManageParameter,
    ManageRange,
  },

  data() {
    return {
      removeParameterLoading: false,
      removeParameterModal: false,
      deleteLoading: false,
      parameters: [],
      parameterId: null,
      manageParameterModal: false,
      manageParameterModalKey: false,
      templateId: null,
      apiService: new ApiService(),
      filter: {
        page: 1,
        pageSize: 1000,
        templateId: null,
      },
      selectedRange: null,
      rangeModal: false,
      rangeModalKey: false,
      rangeId: false,
      deleteRangeModal: false,
    }
  },

  created() {
    this.templateId = this.$route.query.id
    this.list()
  },

  methods: {
    removeParameter() {
      this.removeParameterLoading = true
      this.apiService
        .delete(
          `calibration/v2/standard-template/parameter/${this.parameterId}`
        )
        .then(() => {
          this.filter.page = 1
          this.removeParameterLoading = false
          this.removeParameterModal = false
          this.$toast.success('Template removido!')
          this.list()
        })
        .catch(() => {
          this.removeParameterLoading = false
        })
    },

    openRemoveParameterModal(item) {
      this.parameterId = item.id
      this.removeParameterModal = true
    },

    openRemoveModal(id) {
      this.rangeId = id
      this.deleteRangeModal = true
    },

    removeMetricRange() {
      this.deleteLoading = true
      this.apiService
        .delete(
          'calibration/v2/standard-template/parameter/range/' + this.rangeId
        )
        .then((response) => {
          this.$toast.success('Ponto removido com sucesso!')
          this.deleteRangeModal = false
          this.deleteLoading = false
          this.reloadAndClose()
        })
        .catch(() => {
          this.deleteLoading = false
        })
    },

    openEditParameter(item) {
      this.parameterId = item.id
      this.manageParameterModalKey = !this.manageParameterModalKey
      this.manageParameterModal = true
    },

    openEditRange(item) {
      this.selectedRange = item
      this.parameterId = item.id
      this.rangeModalKey = !this.rangeModalKey
      this.rangeModal = true
    },

    openAddRange(id) {
      this.selectedRange = null
      this.parameterId = id
      this.rangeModalKey = !this.rangeModalKey
      this.rangeModal = true
    },

    reloadAndClose() {
      this.manageParameterModal = false
      this.manageParameterModalKey = !this.manageParameterModalKey

      this.rangeModal = false
      this.rangeModalKey = !this.rangeModalKey

      this.filter.page = 1
      this.list()
    },

    openAddParameterModal() {
      this.parameterId = null
      this.manageParameterModalKey = !this.manageParameterModalKey
      this.manageParameterModal = true
    },

    list() {
      this.filter.templateId = this.templateId

      this.loading = true
      this.apiService
        .get('calibration/v2/standard-template/parameter/paginate', this.filter)
        .then((response) => {
          this.parameters = response.content.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style></style>
